module.exports = __webpack_public_path__ + "static/media/llantas-rodando.06303d9f.svg";